
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 141.7 141.7"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M76.5 0c-15.4 0-23.6.3-38 7.7-42.6 21.7-52 80.8-17.3 113.8 28.2 26.8 70.3 27 99.1.3 34.4-31.9 26.4-91.5-16.6-113.9C98 4.9 84.8 0 76.5 0zM25.6 104.7c2.9-1.3 62.8-62 69.3-68.5 2.8-2.8 8.1-7.1 9.6-10.4-9-7.5-23.4-12.6-39.1-11.2-15.3 1.5-27.1 8.7-34.7 16.4-13.8 13.8-20.7 36.3-14 57 1.8 5.5 5.4 13.6 8.9 16.7zM36 115.3c5 5.7 17.2 10.2 26.9 11.7 12.1 1.9 23.8-.9 32.9-5.3C111.3 114.3 127 96 127 72.9c0-11.8-2.8-26.3-11-35.5-.7-.8-.2-.4-.9-.9C112 38.8 68 83 60.6 90.4c-1.8 1.8-3 3.5-4.8 5.4L36 115.3z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#a20202"}})])
          )
        }
      }
    